export const bailiffDialogAllSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogAll;
export const bailiffDialogOpenAddSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogOpenAdd;
export const bailiffDialogOpenEditSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogOpenEdit;
export const bailiffDialogSelectedSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogSelected;
export const bailiffDialogSearchSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogSearch;
export const bailiffDialogUrlAudioSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogUrlAudio;
//
export const bailiffDialogSecondSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogSecond;
export const bailiffDialogPlaySelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogPlay;
export const bailiffDialogKickSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogKick;
//
export const bailiffDialogSlotSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogSlot;

export const bailiffDialogGapSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogGap;
//
export const bailiffDialogOpenSplitSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogOpenSplit;
export const bailiffDialogOptionSpeakerSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogOptionSpeaker;
//
export const bailiffDialogPreviewSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogPreview;
export const bailiffDialogMergedRawSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogMergedRaw;
export const bailiffDialogDraftEditedSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogDraftEdited;
